import { useQuery } from "graphql-hooks";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Col, Row } from 'reactstrap';
import { useFetchWrapper } from "../../../hooks/useFetchWrapper";
import { useAPIErrorContext } from '../../../contexts/apiErrorContext';

import { Loading } from '../../Shared/Loading';
import Helper from "../../../utilities/helper";
import { AddVehicleSet } from "./AddVehicleSet";
import { EditVehicleSet } from "./EditVehicleSet";
import { ErrorPage } from "../../Shared/ErrorPage";
import { ErrorBanner } from '../../Shared/ErrorBanner';
import { PermissionsGate } from "../../../utilities/PermissionsGate";
import { ACCESS_VALUES, PageNames } from "../../../utilities/constValues";
import { PermissionsRequired } from "../../Shared//PermissionsRequired";
import { Hero } from "../../Shared/Hero";
import { FormContainer } from "../../Shared/Forms/FormContainer";

const NEWVHSET_CMS_QUERY = `query datoQuery {
    pageEstimatorNewVehicleSet {
    fieldHeroTitle
    fieldBodyHeader
    fieldBodyContent1
    fieldBodyContent2
    fieldLinkedText
  }
}`;

const EDITVHSET_CMS_QUERY = `query datoQuery {
  pageEstimatorEditVehicleSet {
    fieldBodyContent1
    fieldBodyHeader
    fieldHeroTitle
  }
}`;

export const AddEditVehicleSets = () => {
    const fetchWrapper = useFetchWrapper();
    const location = useLocation();
    const navigate = useNavigate();
    const [fleetID, setFleetID] = useState('');
    const [vehicleSetID, setVehicleSetID] = useState(0);
    const [isEditForm, setIsEditForm] = useState(false);
    const [fleetName, setFleetName] = useState('');


    useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);

    const { fleetIDParam, vehicleSetIDParam } = useParams();
    if (!fleetID) {
        if (fleetIDParam) {
            setFleetID(fleetIDParam);
        }
    }
    if (!vehicleSetID) {
        if (vehicleSetIDParam) {
            setVehicleSetID(+vehicleSetIDParam);
            setIsEditForm(true);
        }
    }

    var CMS_QUERY = NEWVHSET_CMS_QUERY;
    if (vehicleSetID) {
        CMS_QUERY = EDITVHSET_CMS_QUERY;
    }

    const { loading, error, data } = useQuery(CMS_QUERY, {
        variables: {
            limit: 10
        }
    });
    const { trackError } = useAPIErrorContext();

    const getFleetByID = () => {
        fetchWrapper.get(`fleet/GetByID/${fleetID}`)
            .then((data) => {
                if (data.fleet) {
                    setFleetName(data.fleet.fleetName);
                }
            });
    };

    useEffect(() => {
        if (fleetID) {
            getFleetByID();
        }
    }, [fleetID]);


    const showInstantEstimates = () => {
        navigate("/SampleFleets");
    }

    if (!error && !loading) {
        let datoContentData = data.pageEstimatorNewVehicleSet ? data.pageEstimatorNewVehicleSet : data.pageEstimatorEditVehicleSet;

        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.AddVehicleSets}>
                <div className="addVehicleSetsContainer">
                    <Hero pageTitle={datoContentData.fieldHeroTitle} />
                    <ErrorBanner key="AddEditVehicleSets" errorCode="form" />
                    <Row>
                                <FormContainer title={datoContentData.fieldBodyHeader} description={datoContentData.fieldBodyContent1}>
                                    {isEditForm ? (
                                        <EditVehicleSet fleetID={fleetID} fleetName={fleetName} vehicleSetID={vehicleSetID} />
                                    ) : (
                                        <AddVehicleSet fleetID={fleetID} fleetName={fleetName} />
                                        )}
                                        <Row>
                                            <Col className="formFooter">
                                                {datoContentData.fieldBodyContent2 ? (
                                                <div>
                                                    {datoContentData.fieldBodyContent2.toString().startsWith('<p>') ? (
                                                <div className="contentBlock formContainer ctaMessage" onClick={showInstantEstimates} dangerouslySetInnerHTML={{ __html: datoContentData.fieldBodyContent2.replace("[fieldLinkedText]", "<span>" + datoContentData.fieldLinkedText + "</span>") }} />
                                                    ) : (
                                                    <div className="contentBlock formContainer ctaMessage" onClick={showInstantEstimates} dangerouslySetInnerHTML={{ __html: "<p>" + datoContentData.fieldBodyContent2.replace("[fieldLinkedText]", "<span>" + datoContentData.fieldLinkedText + "</span>") + "</p>" }} />
                                                    )
                                                    }
                                                    </div>
                                                ) : (
                                                    <div className="noCTA" ></div>
                                                )}
                                            </Col>
                                        </Row>
                                </FormContainer>
                    </Row>
                </div>
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        trackError("Dato error", JSON.stringify(error));
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
